import { Injectable } from '@angular/core';
import { isFinite } from 'lodash-es';
import { FormattedValue } from '../models/unit-of-measure.model';
import { ConversionService } from './conversion.service';

@Injectable({ providedIn: 'root' })
export class AreaDisplayService {
    constructor(private conversionService: ConversionService) {}

    getMeasurementFormat(
        areaInMeters: number,
        isMetric: boolean
    ): FormattedValue {
        if (!isFinite(areaInMeters)) {
            return new FormattedValue();
        }

        const { area, units } = this.getFormattedArea(areaInMeters, isMetric);

        return new FormattedValue({
            units,
            value: area,
        });
    }

    // rules are as follows
    // 0 sq ft/m → .5 acres/hectares → 1 sq mi/km
    private getFormattedArea(
        areaInMeters: number,
        isMetric: boolean
    ): { area: string; units: string } {
        let area: string;
        let units: string;

        if (isMetric) {
            const hectares =
                this.conversionService.sqMetersToHectares(areaInMeters);
            const sqKm = this.conversionService.sqMetersToSqKm(areaInMeters);
            if (hectares < 0.5) {
                const places = areaInMeters <= 9.95 ? 1 : 0;
                area = areaInMeters.toFixed(places);
                units = $localize`sq m`;
            } else if (sqKm < 1) {
                area = hectares.toFixed(0);
                units =
                    hectares === 1 ? $localize`hectare` : $localize`hectares`;
            } else {
                const places = sqKm <= 9.95 ? 1 : 0;
                area = sqKm.toFixed(places);
                units = $localize`sq km`;
            }
        } else {
            const acres = this.conversionService.sqMetersToAcres(areaInMeters);
            const sqMi = this.conversionService.sqMetersToSqMiles(areaInMeters);
            if (acres < 0.5) {
                const areaInFeet =
                    this.conversionService.sqMetersToSqFeet(areaInMeters);
                const places = areaInFeet <= 9.95 ? 1 : 0;
                area = areaInFeet.toFixed(places);
                units = $localize`sq ft`;
            } else if (sqMi < 1) {
                area = acres.toFixed(0);
                units = acres === 1 ? $localize`acre` : $localize`acres`;
            } else {
                const places = sqMi <= 9.95 ? 1 : 0;
                area = sqMi.toFixed(places);
                units = $localize`sq mi`;
            }
        }

        return {
            area,
            units,
        };
    }
}
